<template>
  <div class="root">
    <transition name="modal">
      <div v-if="isShown" class="modal-content">
        <div class="modal-mask" @click="cancel"></div>
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="text">
              <b>Thanks for choosing this manga.</b>
              <p>
                This content can only be viewed by the first {{ item.accessLimit }} customers.<br>
                Please try again next time.
              </p>
            </div>
            <div class="modal-button-wrap">
              <div class="modal-error" v-show="error">
                <span>{{ error }}</span>
              </div>
              <template v-if="!isRequesting && item.saleBookId">
                <a class="modal-select-button" @click="purchase">Purchase to continue reading</a>
              </template>
            </div>
            <a class="modal-close" @click="cancel">Close</a>
          </div>
        </div>
      </div>
    </transition>
    <loading-modal
      :is-shown="showLoadingModal"
    ></loading-modal>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../../../../css/variables";

  .modal-content {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
    transition: opacity .3s ease;
  }
  .modal-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .5);
  }
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  .modal-container {
    position: relative;
    width: 745px;
    margin: 0 auto;
    padding: 40px;
    box-sizing: border-box;
    background-color: $color-pc-bg-ffffff;
    color: $color-pc-text-353535;
    border-radius: 4px;
    transition: all .3s ease;
    font-weight: 300;
    font-family: Verdana,Arial;
    -webkit-font-smoothing: antialiased;
  }
  .modal-error {
    display: block;
    margin-bottom: 8px;
    text-align: center;
    color: $color-pc-text-ff6a86;
    font-size: 12px;
  }
  .text {
    width: 460px;
    margin: 0 auto 20px;
    font-size: 14px;
    line-height: 1.2rem;
    text-align: center;
    p {
      margin-bottom: 8px;
    }
    b {
      font-size: 16px;
      display: block;
      border-bottom: $color-pc-border-bebebe 1px solid;
      padding-bottom: 10px;
      margin-bottom: 20px;
    }
    a {
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .modal-button-wrap {
    display: block;
    width:100%;
    margin-top: 30px;
    text-align: center;
  }
  .modal-select-button {
    border: 2px solid $color-pc-border-2e51a2;
    background-color: $color-pc-bg-2e51a2;
    color: $color-pc-text-ffffff;
    font-size: 16px;
    text-align: center;
    display: inline-block;
    width: 300px;
    height: 36px;
    line-height: 33px;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: 2px;
    font-weight: 700;
    margin-left: 20px;
    text-decoration: none;
    opacity: 1;
    &:hover {
      color: $color-pc-text-ffffff;
      text-decoration: none;
      opacity: 0.7;
    }
  }
  .modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    content: '';
    display: block;
    width: 29px;
    height: 29px;
    background: url(/images/manga_store/pc/modal_close@2x.png?v=161115001) no-repeat left top;
    background-size: contain;
    vertical-align: top;
    text-indent: -99999px;
    cursor: pointer;
  }

  /* Transition Effect */
  .modal-enter {
    opacity: 0;
  }
  .modal-leave-active {
    opacity: 0;
  }
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .dark-mode {
    @import "../../../../../css/colors_dark";

    .modal-container {
      background-color: $color-pc-bg-ffffff;
      color: $color-pc-text-353535;
    }
    .modal-error {
      color: $color-pc-text-ff6a86;
    }
    .text {
      b {
        border-bottom: $color-pc-border-bebebe 1px solid;
      }
    }
    .modal-select-button {
      border: 2px solid $color-pc-border-2e51a2;
      background-color: $color-pc-bg-2e51a2;
      color: $color-pc-text-ffffff;
      &:hover {
        color: $color-pc-text-ffffff;
      }
    }
  }

</style>

<script type="text/babel">
  import LoadingModal from "./LoadingModal.vue"

  export default {
    components: {
      LoadingModal,
    },
    data() {
      return {
      }
    },
    props: {
      isShown: Boolean,
      showLoadingModal: Boolean,
      error: String,
      item: Object,
    },
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      purchase() {
        this.$emit('purchase')
      },
    }
  }
</script>
